// 🔧 sponsor_builder.js
// ✅ Purpose: Orchestrates the Sponsor Engine build process
// ✅ Features:
// - Coordinates sponsor generation and seeding
// - Updates DemoContext with created sponsor data
// - Returns standardized execution results
// - Future-ready for Sponsor Levels, Awards, Logos, and Recognition
// - Fully block-commented for clarity and future devs

import { generateSponsors } from "./sponsor_generator";
import { seedSponsors } from "./sponsor_seeder";
import { buildSponsorReport } from "./sponsor_report";

export const buildSponsors = async ({
  demoContext,
} = {}) => {
  console.log("🤝 Sponsor Builder started.");

  // =====================================================
  // Generate sponsor data from the selected template.
  // =====================================================
  const sponsorPlan = generateSponsors({
    demoContext,
  });

  // =====================================================
  // Persist sponsor data to Firestore.
  // =====================================================
  const sponsorResults = await seedSponsors({
    demoContext,
    sponsorPlan,
  });

  // =====================================================
  // Store results on the shared Demo Context.
  // =====================================================
  demoContext.sponsors = sponsorResults.sponsors || [];
  demoContext.sponsorLevels =
    sponsorResults.sponsorLevels || [];

  // =====================================================
  // Return a standardized execution report.
  // =====================================================
  return buildSponsorReport({
    sponsorResults,
  });
};